import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EMPTY, forkJoin } from 'rxjs';
import { catchError, tap, switchMap, map } from 'rxjs/operators';
import { OrganizationsService } from '@app/core/stingray-api/services';
import { StingrayAuthenticationService } from '@app/core/authentication/stingray-authentication.service';
import { User, Organization } from '@app/core/stingray-api/models';
import { Angulartics2GoogleAnalytics } from 'angulartics2';
import { environment } from '@env/environment';
import { OctopusApiAuthenticationService } from '@app/core/authentication/octopus-api-authentication.service';
import { PortalService } from '@app/core/portal/portal.service';

export const shellGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const angulartics2GoogleAnalytics = inject(Angulartics2GoogleAnalytics);
  const portalService = inject(PortalService);
  const stingrayAuthenticationService = inject(StingrayAuthenticationService);
  const octopusApiAuthenticationService = inject(OctopusApiAuthenticationService);
  const organizationsService = inject(OrganizationsService);

  return stingrayAuthenticationService.userProfile$.pipe(
    switchMap(() => {
      return forkJoin([
        organizationsService.getUserById({
          id: stingrayAuthenticationService.organizationId,
          userId: stingrayAuthenticationService.userId
        }),
        organizationsService.getOrganizationById({ id: stingrayAuthenticationService.organizationId })
      ]).pipe(
        tap((shell: [User, Organization]) => {
          if (shell[0] === null) {
            alert('We could not find the user.');
            stingrayAuthenticationService.logout();
          } else if (shell[1] === null) {
            alert('We could not find your organization.');
            stingrayAuthenticationService.logout();
          } else {
            stingrayAuthenticationService.user = shell[0];
            stingrayAuthenticationService.organization = shell[1];
            angulartics2GoogleAnalytics.setUsername(shell[0].id);
            portalService.setPortal(shell[1]);
            octopusApiAuthenticationService.renewToken(shell[1]);
          }
        }),
        map(() => true),
        catchError((e) => {
          console.error('We could not retrieve the user nor the organization.', e);
          alert('We could not retrieve the user nor the organization.');
          window.location.href = environment.stingrayAuthentication.logoutIdentityProviders;
          return EMPTY;
        })
      );
    })
  );
};
